import { getServices } from '@/api/services/services';
import { getCommunities } from '@/api/services/communities';
import { getSpecifications } from '@/api/services/specifications';
import { getRegions } from '@/api/services/regions';
export const formMultilSelectMixin = {
  data() {
    return {
      form: {
        services: [],
        communities: [],
        specifications: [],
        regions: []
      },
      initialServices: [],
      initialCommunities: [],
      initialSpecifications: [],
      initialRegions: [],
      initialLocations: [],
      selectedServices: [],
      selectedCommunities: [],
      selectedSpecifications: [],
      selectedRegions: [],
      selectedLocations: [],
      isCommunitiesLoading: false,
      isServicesLoading: false,
      isSpecificationsLoading: false,
      isRegionsLoading: false,
      isLocationsLoading: false
    };
  },
  watch: {
    selectedServices: {
      immediate: true,
      handler(values) {
        this.form.services = values.map((x) => x.id);
      },
    },
    selectedCommunities: {
      immediate: true,
      handler(values) {
        this.form.communities = values.map((x) => x.id);
      },
    },
    selectedSpecifications: {
      immediate: true,
      handler(values) {
        this.form.specifications = values.map((x) => x.id);
      },
    },
    selectedRegions: {
      immediate: true,
      handler(values) {
        this.form.regions = values.map((x) => x.id);
      },
    },
    selectedLocations: {
      immediate: true,
      handler(values) {
        this.form.regions = []
        this.form.communities = []
        values.forEach(location => {
          if (location.type === 'region') {
            this.form.regions.push(location.id)
          } else {
            this.form.communities.push(location.id)
          }
        })
      },
    },
  },
  methods: {
    async getServicesList() {
      try {
        this.isServicesLoading = true;
        let { data } = await getServices();
        this.initialServices = data;
        this.isServicesLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getCommunitiesList() {
      try {
        this.isCommunitiesLoading = true;
        let { data } = await getCommunities();
        this.initialCommunities = data;
        this.isCommunitiesLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getSpecificationsList() {
      try {
        this.isSpecificationsLoading = true;
        let { data } = await getSpecifications();
        this.initialSpecifications = data;
        this.isSpecificationsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getRegionsList() {
      try {
        this.isRegionsLoading = true;
        let { data } = await getRegions();
        this.initialRegions = data;
        this.isRegionsLoading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getLocations() {
      this.isLocationsLoading = true;
      await this.getCommunitiesList()
      await this.getRegionsList()
      let locations = [...this.initialCommunities, ...this.initialRegions]
      locations.forEach(location => {
        if (location.name) {
          this.initialLocations.push({
            id: location.id,
            name: location.name,
            type: 'community'
          })
        } else {
          this.initialLocations.push({
            id: location.id,
            name: location.value,
            type: 'region'
          })
        }
      })
      this.isLocationsLoading = false;
    }
  },
};
